var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"widgetWrapper",attrs:{"id":"widget-wrapper"}},[_c('widget-header'),_c('div',{staticClass:"content-wrapper"},[_c('benefit-categories'),_c('router-view',{on:{"scrolltop":_vm.handleScrollTop}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }